import moment from "moment-timezone";

import { TaxDeclarationSubmission } from "../api/graphql/schema.generated";

export const declarationSubmissionsSorter = (
  a: TaxDeclarationSubmission,
  b: TaxDeclarationSubmission
): number => (moment(a.submissionDate).isBefore(b.submissionDate) ? 1 : -1);
